<template>
    <div class="body back-gray">
        <div class="wrap end txt-center">
            <p class="font-16">
                응시기간은<br>
                <span class="bold font-20">{{sdate}}~{{edate}}</span><br>
                입니다.
            </p>
        </div>
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="goIntro()">확인</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
    import Footer from '@/components/footer.vue';
    export default {
        name: 'IntroReady',
        components: {
            Footer
        },
        data: () => ({
            sdate:"",
            edate:""
        }),
        mounted() {
            this.sdate = atob(this.$route.params.sdate);
            this.edate = atob(this.$route.params.edate);
        },
        methods: {
            goIntro(){
                location.href='/intro'
            }
        }
    }
</script>